var map = {
	"./bkl1.jpg": "afec",
	"./bkl10.jpg": "a820",
	"./bkl2.jpg": "b260",
	"./bkl3.jpg": "97b5",
	"./bkl4.jpg": "4a61",
	"./bkl5.jpg": "f47d",
	"./bkl6.jpg": "9bb6",
	"./bkl7.jpg": "1c60",
	"./bkl8.jpg": "e8cc",
	"./bkl9.jpg": "4664"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "64ee";